import { io, Socket } from 'socket.io-client';
import { runtimeConfig } from '@/lib/runtime-config';

const BASE_URL = (runtimeConfig.VITE_API_BASE_URL || 'http://localhost').trim();
const RAW_PORT = (runtimeConfig.VITE_API_PORT || '').trim();
const PORT = RAW_PORT || (import.meta.env.DEV ? '9000' : '');

const buildWsUrl = (base: string, port: string): string => {
  const cleaned = base.replace(/\/+$/, '');

  try {
    const parsed = new URL(cleaned);
    if (!parsed.port && port) {
      parsed.port = port;
    }
    return parsed.toString().replace(/\/+$/, '');
  } catch {
    if (/:\d+$/.test(cleaned) || !port) {
      return cleaned;
    }
    return `${cleaned}:${port}`;
  }
};

const WS_URL = buildWsUrl(BASE_URL, PORT);

let socket: Socket | null = null;

export const getSocket = (): Socket | null => socket;

export const connectSocket = (): Socket => {
  if (socket?.connected) {
    return socket;
  }

  socket = io(`${WS_URL}/events`, {
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('[WebSocket] Connected:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[WebSocket] Disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('[WebSocket] Connection error:', error.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const joinTenant = (
  tenantId: string
): Promise<{ success: boolean; error?: string }> => {
  return new Promise((resolve) => {
    if (!socket?.connected) {
      resolve({ success: false, error: 'Socket not connected' });
      return;
    }
    socket.emit(
      'join-tenant',
      { tenantId },
      (response: { success: boolean; error?: string }) => {
        resolve(response);
      }
    );
  });
};

export const leaveTenant = (tenantId: string) => {
  if (socket?.connected) {
    socket.emit('leave-tenant', { tenantId });
  }
};

/**
 * Updates the socket authentication token.
 * Useful when the token is refreshed.
 */
export const updateSocketAuth = () => {
  if (socket) {
    socket.auth = {};
  }
};
